



































































































































































/* General */
import Vue from 'vue'
import moment from 'moment'
import * as routerNames from '@/services/router/router.names'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from 'vue-content-placeholders'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { DueTypeValues, StatusTypeValues } from '@/types'

/* API */
import DashboardAPI from '@/api/modules/dashboard.api'
import {
  IDashboardOutputDashboardItem,
  IDashboardOutputWompDueLog,
  IDashboardOutputWompDueLogWOMPDueRangeInfo,
} from '@/api/types/response.types'

export default Vue.extend({
  name: 'DashboardWomp',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },

  data() {
    return {
      DueTypeValues,
      StatusTypeValues,
      pinnedItems: [] as IDashboardOutputDashboardItem[],
      routerNames,
      isLoading: true,
      navPanels: [],

      assignedTaskCount: 0,
      assignedConversationCount: 0,
      watchedTaskCount: 0,
      watchedConversationCount: 0,
      createdTaskCount: 0,

      dueLog: {} as IDashboardOutputWompDueLog,

      RouteAssistant,
    }
  },

  async created() {
    try {
      this.isLoading = true
      await this.getWompStats()
      this.isLoading = false
    } catch (error) {
      this.$error.emit(error)
    }
  },

  methods: {
    isNoDueItemsDay(dueRangeInfo: IDashboardOutputWompDueLogWOMPDueRangeInfo) {
      return (
        !this.isMultiConvoDayRange(dueRangeInfo) &&
        !this.isSingleConvoDay(dueRangeInfo) &&
        !this.isMultiTaskDayRange(dueRangeInfo) &&
        !this.isSingleTaskDay(dueRangeInfo)
      )
    },
    isMultiConvoDayRange(
      dueRangeInfo: IDashboardOutputWompDueLogWOMPDueRangeInfo,
    ) {
      return dueRangeInfo.dueConversationCount > 1
    },
    isSingleConvoDay(dueRangeInfo: IDashboardOutputWompDueLogWOMPDueRangeInfo) {
      return dueRangeInfo.singleDueConvo !== null
    },
    isMultiTaskDayRange(
      dueRangeInfo: IDashboardOutputWompDueLogWOMPDueRangeInfo,
    ) {
      return dueRangeInfo.dueTaskCount > 1
    },
    isSingleTaskDay(dueRangeInfo: IDashboardOutputWompDueLogWOMPDueRangeInfo) {
      return dueRangeInfo.singleDueTask !== null
    },
    async getWompStats() {
      try {
        const response = await DashboardAPI.get_WompStats()
        this.assignedTaskCount = response.countInfo.assignedTaskCount
        this.assignedConversationCount =
          response.countInfo.assignedConversationCount
        this.watchedTaskCount = response.countInfo.watchedTaskCount
        this.watchedConversationCount =
          response.countInfo.watchedConversationCount
        this.createdTaskCount = response.countInfo.createdTaskCount
        this.dueLog = response.dueLog
      } catch (error) {
        this.$error.emit(error)
      }
    },
    limitedCountText(count: number): string {
      return count < 100 ? `${count}` : '99+'
    },
    getRouteParamsForDueRange(
      dueRange: IDashboardOutputWompDueLogWOMPDueRangeInfo,
    ): any {
      return {
        status_type: StatusTypeValues.ACTIVE,
        due_type: DueTypeValues.DATE_RANGE,
        start_due_date: moment(dueRange.startDay).format('YYYY-MM-DD'),
        end_due_date: moment(dueRange.endDay).format('YYYY-MM-DD'),
        assignee_ids: `${this.$permissions.loggedInUser.id}`,
      }
    },
    getItemRoute(item: IDashboardOutputDashboardItem) {
      if (item.isConversation) {
        return RouteAssistant.getConversationRoute(
          this.$route.params.accountId,
          item.entity.id,
          item.id,
          item.entity.name,
          item.refNumber,
          item.title,
        )
      } else {
        return RouteAssistant.getTaskRoute(
          this.$route.params.accountId,
          item.entity.id,
          item.id,
          this.$permissions,
          item.entity.name,
          item.refNumber,
          item.title,
        )
      }
    },
  },
})
